import React from 'react';
import { withRouter } from 'react-router-dom';
import NavbarContainer from '../nav/navbar_container';
import { Link } from 'react-router-dom';

class LoginForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      errors: {},
      showPassword: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderErrors = this.renderErrors.bind(this);
  }
    
  togglePassword = () => {
    this.setState(prev => ({
      showPassword: !prev.showPassword
    }));
  };
  componentWillMount() {
    this.props.resetSessionErrors();
  }

  update(field) {
    return e => this.setState({
      [field]: e.currentTarget.value
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    if (!this.state.email || !this.state.password) {
      this.setState({
        errors: {
          ...this.state.errors,
          form: "Email and password fields cannot be empty"
        }
      });
      return;
    }

    let user = {
      email: this.state.email,
      password: this.state.password
    };

    this.props.login(user);
  }

  renderErrors() {
    return (
      <ul>
        {Object.keys(this.props.errors).map((error, i) => (
          <li className="login-error-messages" key={`error-${i}`}>
            {this.props.errors[error]}
          </li>
        ))}
        {this.state.errors.form && (
          <li className="login-error-messages">
            {this.state.errors.form}
          </li>
        )}
      </ul>
    );
  }

  render() {
    return (
      <div className="row">
        <NavbarContainer />
        <div className="col-md-4"></div>
        <div className="col-md-4">
          <form className="form-container-login" onSubmit={this.handleSubmit}>
            <div className="form-container-login-2">
              <h1 className="login-header">
             
              </h1>
              <div>Email</div>
              <input
                type="text"
                className="login-form-fields"
                value={this.state.email}
                style={{ color: 'black' }}
                placeholder="Enter your Email Address"
                onChange={this.update('email')}
              />
              <br />
            
            
              <div style={{ position: 'relative' }}>
             

              <input
                type={this.state.showPassword ? "text" : "password"}
                className="login-form-fields"
                value={this.state.password}
                style={{ color: 'black', width: '100%'   }}
                placeholder="Enter your password"
                onChange={this.update('password')}
              />


              {/* Eye Icon */}
              <span
                onClick={this.togglePassword}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  color: '#555'
                }}
              >
                <i className="fa fa-eye"></i>
              </span>
            </div>


              <br />
              {this.renderErrors()}
              <input className="btn btn-primary btn-block" type="submit" value="Unlock" />
              <div className="line"></div>
              <div className="warning-text">
                Forgot your password?
              </div>
              <div className="warning-text">
                bajipro.net
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-4"></div>
      </div>
    );
  }
}

export default withRouter(LoginForm);
